import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';

export const ADJUSTER_REPORT_DAMAGED_PATHS = {
  INFORMATION: {
    list: 'list',
    base: 'damaged-information',
    DRIVER_OWNER: {
      EDIT: {
        driver: 'driver-info',
        certificate: 'certificate-information',
        driverContact: 'contact-info',
        owner: 'owner-info',
        ownerContact: 'owner-contact-info',
        otherDamaged: 'other-damaged',
        otherDamagedContact: 'contact-info',
      },
      show: 'show',
      otherShow: 'other-show',
    },
    VEHICLE_INFORMATION: {
      EDIT: { base: 'vehicle-information', partTwo: 'part-two' },
      show: 'show-vehicle-information',
    },
    EXPERT: {
      base: 'expert',
      visitInformation: 'visit_information',
      visitInformationShow: 'show_visit_information',
      otherVisitInformation: 'visit_other_information',
      otherVisitInformationShow: 'show_other_visit_information',
      wages: 'wages',
      wagesShow: 'show_wages',
      substitutionParts: 'substitution_parts',
      substitutionPartsForm: 'form',
      substitutionPartsShow: 'show_substitution_parts',
      costs: 'costs',
      costsShow: 'show-costs',
      otherCosts: 'other-costs',
      otherCostsShow: 'show_other-costs',
    },
    BANK_ACCOUNT: { edit: 'bank-account', show: 'show-bank-account' },
    PROPERTY_INSURANCE: {
      edit: 'property-insurance',
      show: 'property-insurance-show',
    },
  },
  IMAGES: {
    list: 'list',
    base: 'damaged-images',
    ADJUSTER: {
      base: 'adjuster',
      DOCUMENT: { edit: 'document', show: 'show-document' },
      ADDITIONAL: { edit: 'attached', show: 'show-attached' },
      OTHER_ADDITIONAL: 'other-attached',
      OTHER_DAMAGED: {
        edit: 'other-damaged',
        show: 'show-other-damaged',
        images: 'images',
      },
      VEHICLE: {
        base: 'vehicle',
        damagedPoints: 'damaged-points',
        takePhotoGuide: 'take-photo-guide',
        takePhotoFlow: 'take-photo-flow',
        previewImages: 'preview-images',
        editablePreviewImages: 'editable-preview-images',
        showPreviewImages: 'show-preview-images',
        offlineImages: 'vehicle-offline-image',
        previewImageDamagePoint: 'preview-image-damage-point',
      },
    },
    CUSTOMER: {
      base: 'customer',
      vehicleImages: 'vehicle',
      document: 'document',
      additional: 'attached',
      otherDamaged: 'damaged',
    },
    SIGNATURE: { edit: 'signature', show: 'show-signature' },
    corrective: 'corrective',
  },
} as const;

export const ADJUSTER_REPORT_DAMAGED_LINKS = {
  damagedListInformation: ({ id }: { id: number | string }) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.base}/${ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.list}`,
  damagedListImages: ({ id }: { id: number | string }) =>
    `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.base}/${ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.list}`,
  DAMAGED_INFORMATION: ({
    damagedId,
    id,
  }: {
    id: number | string;
    damagedId: number | string;
  }) => {
    const DAMAGED_INFORMATION = ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION;
    const damagedInformationBase = `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${DAMAGED_INFORMATION.base}/${damagedId}`;
    const expertBase = `${damagedInformationBase}/${DAMAGED_INFORMATION.EXPERT.base}`;

    return {
      damagedInformationTabsPage: damagedInformationBase,
      OTHER_OWNER_INFORMATION: {
        owner: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.otherDamaged}`,
        ownerContact: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.otherDamaged}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.otherDamagedContact}`,
        show: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.show}`,
      },
      DRIVER_OWNER_INFORMATION: {
        driver: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.driver}`,
        certificate: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.certificate}`,
        driverContact: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.driverContact}`,
        owner: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.owner}`,
        ownerContact: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.owner}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.ownerContact}`,
        otherDamaged: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.otherDamaged}`,
        otherDamagedContact: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.otherDamaged}/${DAMAGED_INFORMATION.DRIVER_OWNER.EDIT.otherDamagedContact}`,
        show: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.show}`,
        otherShow: `${damagedInformationBase}/${DAMAGED_INFORMATION.DRIVER_OWNER.otherShow}`,
      },
      VEHICLE_INFORMATION: {
        partOne: `${damagedInformationBase}/${DAMAGED_INFORMATION.VEHICLE_INFORMATION.EDIT.base}`,
        partTwo: `${damagedInformationBase}/${DAMAGED_INFORMATION.VEHICLE_INFORMATION.EDIT.base}/${DAMAGED_INFORMATION.VEHICLE_INFORMATION.EDIT.partTwo}`,
        show: `${damagedInformationBase}/${DAMAGED_INFORMATION.VEHICLE_INFORMATION.show}`,
      },
      OTHER_EXPERT: {
        visitInformation: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.otherVisitInformation}`,
        visitInformationShow: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.otherVisitInformationShow}`,
      },
      EXPERT: {
        entryTabs: expertBase,
        wages: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.wages}`,
        wagesShow: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.wagesShow}`,
        substitutionParts: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.substitutionParts}`,
        substitutionPartsForm: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.substitutionParts}/${DAMAGED_INFORMATION.EXPERT.substitutionPartsForm}`,
        substitutionPartsShow: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.substitutionPartsShow}`,
        costs: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.costs}`,
        costsShow: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.costsShow}`,
        otherCosts: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.otherCosts}`,
        otherCostsShow: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.otherCostsShow}`,
        visitInformation: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.visitInformation}`,
        visitInformationShow: `${expertBase}/${DAMAGED_INFORMATION.EXPERT.visitInformationShow}`,
      },
      BANK_ACCOUNT: {
        edit: `${damagedInformationBase}/${DAMAGED_INFORMATION.BANK_ACCOUNT.edit}`,
        show: `${damagedInformationBase}/${DAMAGED_INFORMATION.BANK_ACCOUNT.edit}/${DAMAGED_INFORMATION.BANK_ACCOUNT.show}`,
      },
      PROPERTY_INSURANCE: {
        edit: `${damagedInformationBase}/${DAMAGED_INFORMATION.PROPERTY_INSURANCE.edit}`,
        show: `${damagedInformationBase}/${DAMAGED_INFORMATION.PROPERTY_INSURANCE.edit}/${DAMAGED_INFORMATION.PROPERTY_INSURANCE.show}`,
      },
    };
  },
  DAMAGED_IMAGES: ({
    damagedId,
    id,
  }: {
    id: number | string;
    damagedId: number | string;
  }) => {
    const DAMAGED_IMAGES_BASE = `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.base}/${damagedId}`;
    const ADJUSTER_IMAGES_BASE = `${DAMAGED_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.base}`;
    const ADJUSTER_VEHICLE_BASE = `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.base}`;
    const CUSTOMER_IMAGES_BASE = `${DAMAGED_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.base}`;

    return {
      imagesTabPage: DAMAGED_IMAGES_BASE,
      ADJUSTER_VEHICLE: {
        damagedPoints: `${ADJUSTER_VEHICLE_BASE}`,
        takePhotoGuide: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.takePhotoGuide}`,
        takePhotoFlow: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.takePhotoFlow}`,
        previewImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.previewImages}`,
        editablePreviewImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.editablePreviewImages}`,
        showPreviewImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.showPreviewImages}`,
        offlineImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.offlineImages}`,
        previewImageDamagePoint: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.VEHICLE.previewImageDamagePoint}`,
      },
      ADJUSTER_DOCUMENT: {
        edit: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.DOCUMENT.edit}`,
        show: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.DOCUMENT.show}`,
      },
      ADJUSTER_ADDITIONAL: {
        edit: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.ADDITIONAL.edit}`,
        show: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.ADDITIONAL.show}`,
      },
      ADJUSTER_OTHER_ADDITIONAL: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_ADDITIONAL}`,
      ADJUSTER_OTHER_DAMAGED: {
        edit: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED.edit}`,
        images: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED.edit}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED.images}`,
        show: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.ADJUSTER.OTHER_DAMAGED.show}`,
      },
      customerVehicle: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.vehicleImages}`,
      customerDocument: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.document}`,
      customerAdditional: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.additional}`,
      customerOtherDamaged: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.CUSTOMER.otherDamaged}`,
      SIGNATURE: {
        edit: `${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.SIGNATURE.edit}`,
        show: `${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.SIGNATURE.show}`,
      },
      corrective: `${ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.corrective}`,
    };
  },
};
